// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__15X5S","title":"ClientInsurance_title__kruSw","itemText":"ClientInsurance_itemText__1ZLiG"};